export function removeTrailingSlash(string: string): string {
  return string.replace(/\/+$/, '');
}
